import bem from 'utils/bem';

export const block = bem('project-button');
